var Vendd = (function (Vendd) {
	'use strict';

	Vendd.MessageBus.subscribe(Vendd.Export.Messages.GetListingExport, Vendd.Export, function (envelope) {
		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.Export, new Vendd.Export.Messages.GetListingExportSuccess(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Export, new Vendd.Export.Messages.GetListingExportFailure(response));
		}

		var options = {
			url: 'ExportService.svc/GetListingExport',
			data: {
				exportCode: envelope.message.data.exportCode,
				listingId: envelope.message.data.listingId
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	return Vendd;

})(Vendd || {});
